import React from "react";
import { makeIconDef } from "./makeIconDef";
export var PlusIconDef = {
    plus: makeIconDef('plus', {
        regular: function () { return React.createElement("path", { d: "M4 12H20M12 4V20", stroke: "currentColor" }); },
        filled: function () { return React.createElement("path", { d: "M4 12H20M12 4V20", stroke: "currentColor", strokeWidth: "2" }); }
    }),
};
